import { render, staticRenderFns } from "./SingleNews.vue?vue&type=template&id=338f58de&scoped=true&"
import script from "./SingleNews.vue?vue&type=script&lang=js&"
export * from "./SingleNews.vue?vue&type=script&lang=js&"
import style0 from "./SingleNews.vue?vue&type=style&index=0&id=338f58de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f58de",
  null
  
)

export default component.exports